module.exports = __webpack_public_path__ + "img/mac-folder.e68f5980.png";